/* unplugin-vue-components disabled */import script from "./Chinese.vue?vue&type=script&setup=true&lang=ts"
export * from "./Chinese.vue?vue&type=script&setup=true&lang=ts"

import "./Chinese.vue?vue&type=style&index=0&id=95627d60&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95627d60"]])

export default __exports__